export const MO_CONNECT_POPUP_SIZE = '60vw';
